import * as Sentry from '@sentry/vue'

export function reportWarning(message, extra = {}) {
  console.warn(message, extra)
  Sentry.captureMessage(message, { level: 'warning', extra })
}

export function reportError(errOrMessage, extra = {}) {
  if (errOrMessage instanceof Error) {
    console.error(errOrMessage.message, extra)
    Sentry.captureException(errOrMessage, { level: 'error', extra })
  } else {
    const message = String(errOrMessage)
    console.error(message, extra)
    Sentry.captureMessage(message, { level: 'error', extra })
  }
}
